import React, { useState, useEffect } from "react";
import Footer from "../layout/Footer";
import Header from "../layout/Header";
import Toolbar from "../navigation/Toobar";
import { Link } from "react-router-dom";
import useSEO from "../hooks/useSEO";
import SeoPanel from "../components/seo/SeoPanel";
import { buildBreadcrumbJsonLd, getSiteBrand } from "../utils/seo";

const PROMOTION_BREADCRUMBS = [
  { name: 'Home', path: '/' },
  { name: 'Promotions', path: '/promotion' },
];

function Promotion({promotions, globalData}) {
   const [loading, setLoading] = useState(true);
  const [selectedPromotion, setSelectedPromotion] = useState(null); 
  const [showModal, setShowModal] = useState(false); 
  const [loadingDetails, setLoadingDetails] = useState(false);

  const brandName = globalData?.general?.site_title || getSiteBrand();

  useSEO({
    title: 'Promotions & Bonus Offers',
    description: `Explore ${brandName} promotions and bonus offers: welcome bonus on your first deposit, rebates on betting turnover, free spins, referral rewards and VIP perks for players in Bangladesh.`,
    keywords: `betting bonus bangladesh, welcome bonus, deposit bonus, free spins, rebate cashback, referral bonus, VIP rewards`,
    path: '/promotion',
    brand: brandName,
    jsonLd: [buildBreadcrumbJsonLd(PROMOTION_BREADCRUMBS)],
  });



  // Function to handle modal open
  const handleShowModal = async (promotionId) => {
      setLoadingDetails(true); // Start loading details
      try {
          const response = await fetch(`${process.env.REACT_APP_API_URL}/api/promotions/${promotionId}`);
          if (!response.ok) {
              throw new Error("Failed to fetch promotion details");
          }
          const promotionDetails = await response.json();
          setSelectedPromotion(promotionDetails); // Set the selected promotion
      } catch (error) {
          console.error("Error fetching promotion details:", error);
      } finally {
          setLoadingDetails(false); // Stop loading details
          setShowModal(true); // Show the modal
      }
  };

  // Function to handle modal close
  const handleCloseModal = () => {
      setShowModal(false);
      setSelectedPromotion(null); 
  };
   const [selectedType, setSelectedType] = useState("All");

  // ✅ Unique promotion types
  const uniqueTypes = [...new Set(promotions.map(p => p.promotion_type))];

  // ✅ Filter Logic
  const filteredPromotions =
    selectedType === "All"
      ? promotions
      : promotions.filter(p => p.promotion_type === selectedType);
  return (
  <div className="v-application--wrap">
    <div>
     
     <Header/>
      <div className="row hidden-sm-and-down header-top no-gutters align-center justify-space-between">
        <div className="header-column col col-5">
          <a href="/" className="router-link-active">
            <img
              src="/static/svg/logo.svg"
              alt=""
              width={200}
              height={70}
              style={{ float: "left", paddingLeft: "10px" }}
            />
          </a>
        </div>
       
      </div>
    
      <div className="body">
        <div>
          <div className>
            <div className="row hidden-md-and-up" style={{ margin: "0px" }}>
              <div className="mobile-header text-center col col-12">
                Promotion
              </div>
            </div>
            <div className="hidden-md-and-up v-card v-sheet theme--dark">
              <div className="row no-gutters justify-space-around">
                <div className="col col-12">
                  <div className="mobile-menu-card-wrapper v-card v-sheet theme--dark">
                    <button
                      type="button"
                      className="mobile-category-menuBtn v-btn v-btn--block v-btn--is-elevated v-btn--has-bg theme--dark v-size--default"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span className="v-btn__content">
                        All
                        <i
                          aria-hidden="true"
                          className="v-icon notranslate v-icon--right mdi mdi-menu-down theme--dark"
                          style={{ fontSize: "36px" }}
                        />
                      </span>
                    </button>
                  
                  </div>
                  <div className="v-menu">{/**/}</div>
                </div>
              </div>
            </div>
            <div
              className="bonus-category-menu justify-space-around hidden-sm-and-down mb-2 v-card v-sheet theme--dark"
              style={{ boxShadow: "none" }}
            >
              <div className="row promotion-menu px-2 no-gutters">
                 {uniqueTypes.map((type, index) => (
                <button
                  type="button"
                   onClick={() => setSelectedType(type)}
                  className="my-2 px-3 py-2 page-promotion-button v-btn v-btn--text theme--dark v-size--default conditional-styles"
                  style={{ height: "auto" }}
                >
                  <span className="v-btn__content">
                    <div className="row no-gutters">
                      <div className="px-0 text-center col col-12">
                        <label className="bonus-category-menu-title px-2">
                          {type}
                        </label>
                      </div>
                    </div>
                  </span>
                </button>
               ))}
               
             
               
              
             
              </div>
            </div>
            <div className="row d-flex mt-0 pt-0 align-end justify-space-around">
              <div className="col-md-12 col">
                <div
                  className="promotion-card-container v-card v-sheet theme--dark"
                  style={{ boxShadow: "none" }}
                >
                  <div className="v-card__text">
                    <div className="row align-center">
                        {promotions.length > 0 ? (
                                      promotions.map((promotion) => (
                      
                      <div className="pa-3 col-md-6 col-lg-6 col-12">
                        <div
                          className="v-card v-sheet theme--dark promotion-box"
                          style={{ boxShadow: "none" }}
                        >
                          <div className="v-image v-responsive promotion-image-box hidden-md-and-down theme--dark">
                            <div
                              className="v-responsive__sizer"
                              style={{ paddingBottom: "37.0748%" }}
                            />
                            <div
                              className="v-image__image v-image__image--preload v-image__image--contain"
                              style={{ backgroundPosition: "center center" }}
                            />
                            <div className="v-responsive__content" />
                          </div>
                          <div className="v-image v-responsive promotion-image-box hidden-lg-and-up theme--dark">
                            <div
                              className="v-responsive__sizer"
                              style={{ paddingBottom: "37.0748%" }}
                            />
                            <div
                              className="v-image__image v-image__image--contain"
                              style={{
                                backgroundImage:
                                  `url(${process.env.REACT_APP_API_URL}/storage/${promotion.thumbnail})`,
                                backgroundPosition: "center center",
                              }}
                            />
                            <div className="v-responsive__content" />
                          </div>
                          <div className="row promotion-box-row no-gutters">
                            <div className="col-12 col">
                              <div className="row promotion-desc-box no-gutters">
                                <div className="col col-12">
                                  <p className="font-weight-bold promotion-desc-title mb-1">
                                  {promotion.name}
                                  </p>
                                  <p className="d-block text-truncate promotion-menu-desc mb-1">
                                    {promotion.desc ? promotion.desc.split(' ').slice(0, 5).join(' ') : 'No description available'}
                                  </p>
                                </div>
                                <div
                                  className="col-md-3 col-6"
                                  style={{
                                    alignSelf: "flex-end",
                                    paddingRight: "5px",
                                  }}
                                >
                                  <button
                                    type="button"
                                     onClick={() => handleShowModal(promotion.id)}
                                    className="primary-button pa-1 font-weight-bold mobile-detail-btn v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default"
                                    style={{ height: "auto" }}
                                  >
                                    <span className="v-btn__content">
                                      Read More
                                    </span>
                                  </button>
                                </div>
                                <div
                                  className="col-md-3 col-6"
                                  style={{
                                    alignSelf: "flex-end",
                                    paddingLeft: "5px",
                                  }}
                                >
                                  <Link
                                    to="/deposit"
                                    type="button"
                                    className="full-width font-weight-bold pa-1 buttonPrimary primary-button theme--light mobile-apply-btn v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default"
                                    style={{ height: "auto" }}
                                  >
                                    <span className="v-btn__content">
                                      Claim Now
                                    </span>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                       ))
                      ) : (
                        <p>No promotions available</p>
                      )}

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div data-v-c5353408 role="dialog" className="v-dialog__container">
              {/**/}
            </div>
            {/**/}
          </div>
        </div>

        <SeoPanel
          id="seo-promotion"
          preview={
            <>
              <nav className="seo-breadcrumb" aria-label="Breadcrumb">
                <Link to="/">Home</Link> <span aria-hidden="true">›</span>{' '}
                <span aria-current="page">Promotions</span>
              </nav>

              <h1 className="seo-h1" id="seo-promotion-title">
                Promotions, bonuses and rewards at {brandName}
              </h1>
              <p className="seo-text">
                Every offer on this page is built for players who fund their account in Bangladeshi
                Taka and play sports, casino or slots. Read the rules of an offer, tap Apply Now
                and follow the steps shown in the promotion details to claim it.
              </p>
            </>
          }
        >
          <h2 className="seo-h2">Types of promotions you can claim</h2>
          <ul className="seo-list">
            <li>
              <strong>Welcome / first deposit bonus:</strong> extra balance on your first deposit to
              get your account started.
            </li>
            <li>
              <strong>Rebate and cashback:</strong> a percentage of betting turnover returned to
              your wallet weekly or monthly.
            </li>
            <li>
              <strong>Free spins and slot bonuses:</strong> free rounds on selected slots, perfect
              for short sessions.
            </li>
            <li>
              <strong>Referral rewards:</strong> commission when a friend registers through your
              link and starts playing.
            </li>
            <li>
              <strong>VIP and loyalty rewards:</strong> higher rebates, faster withdrawals and extra
              perks for regular players.
            </li>
            <li>
              <strong>Seasonal and sports specials:</strong> limited-time offers around cricket
              tournaments, football leagues and festival periods.
            </li>
          </ul>

          <h2 className="seo-h2">How to claim a promotion</h2>
          <ul className="seo-list">
            <li>
              Open the offer you want and read its rules, including the validity period and the
              turnover requirement.
            </li>
            <li>
              Deposit the qualifying amount, or opt in from your account if the promotion requires
              it.
            </li>
            <li>
              Meet the turnover requirement by playing the eligible games listed in the terms, then
              withdraw your balance as usual.
            </li>
          </ul>

          <h2 className="seo-h2">Bonus terms worth knowing</h2>
          <p className="seo-text">
            Bonuses have limits: one claim per player and per payment method, a deadline to use the
            offer, a maximum bet while the bonus is active and a wagering requirement before
            withdrawal. Accounts that abuse bonuses or use automated play may lose the bonus and
            any related winnings, so play within the rules and keep to the limits shown in each
            offer.
          </p>

          <h2 className="seo-h2">Helpful pages</h2>
          <ul className="seo-links">
            <li>
              <Link to="/signup">Create an account</Link>
            </li>
            <li>
              <Link to="/games">Play sports, live casino and slots</Link>
            </li>
            <li>
              <Link to="/faq">How deposits, withdrawals and turnover work</Link>
            </li>
            <li>
              <Link to="/terms-and-conditions">Full terms and conditions</Link>
            </li>
          </ul>
        </SeoPanel>

        <Toolbar/>
        <Footer sociallink={globalData.socialLinks || {}}/>
      </div>
      {/**/}
    </div>
     {showModal && (
    <div  role="document" tabIndex={0} data-v-c5353408 style={{backgroundColor: 'rgba(0, 0, 0, 0.5)'}} className="v-dialog__content v-dialog__content--active" >
  <div className="v-dialog v-dialog--active v-dialog--persistent" style={{transformOrigin: 'center center', maxWidth: '1100px'}}>
    <div data-v-c5353408 className="dialog-card v-card v-sheet theme--dark">
      <div data-v-c5353408 className="row no-gutters justify-space-between dialog-header pt-3 px-3">
        <div data-v-c5353408 className="col col-11">
          <label data-v-c5353408 className="dialog-title pt-3 ma-0 text-capitalize d-block full-width"> Promotion</label>
          {/**/}
        </div>
        <div  onClick={handleCloseModal} data-v-c5353408 className="col col-1">
          <button data-v-c5353408 type="button" className="v-icon notranslate v-icon--link mdi mdi-close theme--dark dialog-close-icon" /></div>
        {/**/}
      </div>
      <div data-v-c5353408 className="row no-gutters px-3 py-3">
        <div data-v-c5353408 className="col col-12"><hr data-v-c5353408 role="separator" aria-orientation="horizontal" className="dialog-divider v-divider theme--dark" /></div>
      </div>
      <div data-v-c5353408 className="row d-block dialog-row no-gutters pa-3 pt-0">
        <div className="container px-3 maxFrameHeight">
          <div className="cms_bonus_content text-left" style={{width: '100%'}}>
            <div className="row no-gutters">
              <div className="col col-12">
                <button type="button" className="mb-4 full-width font-weight-bold pa-2 primary-button theme--light mobile-apply-btn v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default" style={{width: '100%'}}>
                  <span className="v-btn__content">
                    Apply Now
                  </span>
                </button>
              </div>
              <div className="col-sm-10 col-md-10 col-lg-10 col-12">
                <p className="font-weight-bold mb-0">{selectedPromotion ? selectedPromotion.name : ''}</p>
                {/* <p>Oct 21, 2025 00:00:00 (GMT +06:00) - Jan 01, 2100 00:00:00 (GMT +06:00)</p> */}
              </div>
              {/**/}
            </div>
            <div className="row no-gutters">
              <div className="cms_bonus_content text-left col col-12">
                <p>   {selectedPromotion.desc}</p>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  )}
  </div>


  );
}

export default Promotion;